import {environment} from '../environments/environment';

export const constants = {
	/* eslint-disable @typescript-eslint/naming-convention */
	APP_USE: {HOME: 'H', LAZBOY: 'L'},
	AUTHENTICATED_USER: 'authenticated_user',
	TWO_FACTOR_MESSAGE: '2 factor authentication email sent',
	API_URL_NAME: 'apiUrl',
	API_ROLE: 'apiRole',
	API_CAPTION: 'apiCaption',
	STORE_LOCATION_ID: 'storeLocationId',
	ACTIVE_ORDER_ID: 'activeOrderId',
	STORE_NAME: 'storeName',
	CART: 'cart',
	CART_INDEX: 'cart_index',
	CART_PREFIX: 'cart_',
	USERNAME: 'username',
	LAST_USERNAME: 'lastUsername',
	LOGIN_ROUTE: '/login',
	UNAUTHENTICATED_ROUTES: [
		'/login',
		'/',
		'/forgot-password'
	],
	GLOBAL_APP_TIMEOUT: 60000,
	NETSUITE_SAVE_TIMEOUT: 120000,
	LOGIN_TIMEOUT: 20000,

	FAILED_RETRIEVING_CATEGORIES: 'Failed retrieving categories',
	LOGGED_OUT_FOR_INACTIVITY: 'You have been logged out due to inactivity',

	CACHE_KEYS: {
		CATEGORIES: 'categories',
		BRANDS: 'brands',
		RANGES: 'ranges',
		LOCATIONS: 'locations',
		CONFIG: 'config'
	},

	NETSUITE_DATE_FORMAT: 'dd/MM/yyyy',
	NICE_DATE_FORMAT: 'd MMM Y',
	ISO_DATE_FORMAT: 'yyyy-MM-dd',
	MGRSPEC_PASSCODE_NAME: 'dm_mgr',

	NO_STOCK_MESSAGE: 'There is no stock at the selected location',

	INCLUDE_CART_INVENTORY: true
	/*  eslint-enable @typescript-eslint/naming-convention */
};
